import interceptors from "./interceptors/index";

const fetchAlerts = (format) => {
  return interceptors({
    url: "/online-promocional/alerts",
    method: "GET",
    params: { p_formato: format },
  });
};

export { fetchAlerts };
